import { useConfigurableContext } from '@graphcommerce/magento-product-configurable';
import { Button } from '@mui/material'
import Link from 'next/link';
import { useContext, useEffect } from 'react'
import TemplateContext from '../TemplateContext/template-context';

function CustomizeButton(props) {
  const { product, sx, currentSku, disabled = false, tetherList, by_use_id } = props;

  const configCtx = useConfigurableContext(currentSku);
  const { setParams } = useContext(TemplateContext);

  let variations: Array<any> = [];
  if (configCtx.variants[0]?.attributes) {
    variations = configCtx.variants[0]?.attributes;
  }

  let newObj = {};

  useEffect(() => {
    if (tetherList) {
      let newList = tetherList;
      if (variations) {
        for (let i = 0; i < variations.length; i++) {
          for (let tether of newList) {
            if (variations[i].code == tether.uid) {
              if (newObj[variations[i].code]) {
                delete newObj[variations[i].code]
              }
              Object.assign(newObj, { [variations[i]?.code + "_val"]: { in: [variations[i]?.value_index?.toString()] } });
              break;
            } else {
              Object.assign(newObj, { [variations[i]?.code]: { in: [variations[i]?.value_index?.toString()] } });
            }
          }
        }
      }
    }
  });

  return (
    <>
      {disabled ? (<Button
        color='primary'
        variant='pill'
        size='large'
        disabled
        sx={sx}
      >
        Customize
      </Button>) : (
        <Link href={"/templates/" + product.url_key} style={{ textDecoration: 'none' }}>
          <Button
            color='primary'
            variant='pill'
            size='large'
            sx={sx}
            onClick={
              (e) => { by_use_id ? setParams({ filters: { ...newObj, shop_by_use_val: { in: [by_use_id.toString()] } } }) : setParams({ filters: { ...newObj } }); }
            }
          >
            Customize
          </Button>
        </Link>
      )}
    </ >
  )
}

export default CustomizeButton
